import { EziDebitForm } from "./eziDebitForm";
export default EziDebitForm;
